import React from "react";
import Divider from "@material-ui/core/Divider";

import { StyledGrid } from "components/simple";
import { spacingDefaults, fontSize } from "style/constants";

interface GroupHeaderProps {
  name: string;
  pillarScore: number | null;
}

const GroupHeader: React.FC<GroupHeaderProps> = ({ name, pillarScore }: GroupHeaderProps) => (
  <>
    <Divider />
    <StyledGrid padding={spacingDefaults.large}>
      <StyledGrid container direction="row" justifyContent="space-between" alignItems="center">
        <StyledGrid fontSize={fontSize.medium}>
          <strong> {name}</strong>
        </StyledGrid>
        <StyledGrid paddingRight={spacingDefaults.xlarge} fontSize={fontSize.medium}>
          <strong>{pillarScore}</strong>
        </StyledGrid>
      </StyledGrid>
    </StyledGrid>
  </>
);

export default GroupHeader;
